export const ACTION_TYPE_SET_PAGE = "ForgetUserName/setPage";
export const setPage = (page) => ({
    type: ACTION_TYPE_SET_PAGE,
    page: page
});